<template>
  <div class="product-info-param">
    <div class="msg-list">
      <div class="msg-item">
        <div class="key">
          {{ $t('dms_product_info_param.lun_zi_zhi_jing') }}
        </div>
        <div class="val">{{ data.wheelDiameter }}m</div>
      </div>
      <div class="msg-item">
        <div class="key">
          {{ $t('dms_product_info_param.lun_zi_zhou_chang') }}
        </div>
        <div class="val">{{ data.wheelPerimeter }}m</div>
      </div>
      <div class="msg-item">
        <div class="key">{{ $t('dms_product_info_param.shua_zi_kuan_du') }}</div>
        <div class="val">{{ data.brushWidth }}m</div>
      </div>
      <div class="msg-item">
        <div class="key">{{ $t('dms_product_info_param.zxqjmj') }}（{{ $t('dms_product_info_param.lun_zi_zhou_chang') }}*{{ $t('dms_product_info_param.shua_zi_kuan_du') }}）</div>
        <div class="val">{{ data.minCleanArea }}㎡</div>
      </div>
      <!-- <div class="msg-item">
        <div class="key">
          {{ $t('label_daily_max_work_hours') }}
        </div>
        <div class="val">{{ data.maxWorkHourPerDay }}h</div>
      </div> -->
      <!-- <div class="msg-item">
        <div class="key">
          {{ $t('label_daily_max_charge_hours') }}
        </div>
        <div class="val">{{ data.maxChargingHourPerDay }}h</div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.product-info-param {
  .msg-list {
    margin-top: 24px;
    .msg-item {
      line-height: 38px;
      font-size: 12px;
      overflow: hidden;
      border-bottom: 1px solid #eef2f8;
      color: #98a6ad;
      .deep-gray {
        color: #6c757d;
      }
      .blue {
        color: #0d9ae0;
      }
      .underline {
        text-decoration: underline;
        &:hover {
          cursor: pointer;
        }
      }
      .key {
        float: left;
      }
      .val {
        float: right;
      }
      .data {
        float: right;
        margin-right: 10px;
      }
    }
  }
}
</style>
